var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlDistWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1300_3359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1300_3359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 9.29556C21.9007 9.64205 21.836 9.99949 21.6957 10.3327C21.2637 11.3448 20.4832 11.8712 19.3661 11.8821C18.8405 11.8868 18.3149 11.8868 17.7894 11.8821C17.2312 11.8759 16.8733 11.5466 16.863 11.039C16.8528 10.5313 17.2076 10.1786 17.7626 10.1598C18.2482 10.1442 18.7346 10.1598 19.221 10.1598C19.2999 10.1598 19.3787 10.1598 19.4575 10.1598C19.9345 10.1246 20.2506 9.66317 20.2601 8.99131C20.2695 8.29911 19.9637 7.75475 19.5009 7.74614C18.3073 7.72424 17.113 7.7391 15.8744 7.7391V20H6.14685V7.73127H2.723C2.61766 7.72427 2.51185 7.72927 2.40766 7.74614C1.96065 7.85017 1.67763 8.46024 1.74701 9.154C1.81008 9.77972 2.12779 10.1434 2.64022 10.1528C3.0478 10.1598 3.4546 10.1528 3.86218 10.1528C4.42586 10.1622 4.82162 10.5353 4.80821 11.0358C4.79796 11.5223 4.41403 11.8688 3.85666 11.8743C3.34423 11.879 2.83179 11.9071 2.32015 11.8579C1.15258 11.7437 0.302732 10.8763 0.0748953 9.62564C0.054888 9.53903 0.029881 9.45364 0 9.36988V8.50952C0.0268043 8.41175 0.0591271 8.31476 0.0788361 8.21543C0.328747 6.89204 1.30632 6.00352 2.54404 6.00274C8.17872 5.99909 13.8134 5.99909 19.4481 6.00274C20.3578 6.00274 21.0839 6.4024 21.5096 7.20488C21.7359 7.63194 21.8384 8.12392 21.9961 8.58616L22 9.29556ZM12.9394 18.3395C13.0308 17.4447 13.5519 16.9927 14.3789 16.8746V7.75787H7.67785V16.8792C8.52297 17.0005 9.01806 17.4588 9.10872 18.3043C9.16133 18.3209 9.21547 18.3321 9.27034 18.3379C10.4734 18.3403 11.678 18.3395 12.9394 18.3395Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlDistWithdraw);
export default __webpack_public_path__ + "static/media/bl_dist_withdraw.2faf81bd8ce02ca9339d897ec2d5f43f.svg";
export { ForwardRef as ReactComponent };